import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/laboratory-manager/new',
  title: 'Cadastro Gerente de Laboratório',
  endpoint: '/app/person',
  breadcrumbs: [],
}
